module.exports = __webpack_public_path__ + "img/weddings_11_V.3441cccf.jpg";